import { LogoutIcon } from 'assets/images';
import { createToolbarEvent, sendAnalytics } from 'store/modules/analytics';
import { leaveConference } from 'store/modules/app/actions';
import { translate } from 'store/modules/base/i18n';
import { connect } from 'store/modules/base/redux';
import utils from 'util/utils';
import AbstractButton from './AbstractButton';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import React from 'react';
import once from 'lodash/once';

/**
 * Component that renders a toolbar button for leaving the current conference.
 *
 * @augments AbstractHangupButton
 */
class HangupButton extends AbstractButton {
  accessibilityLabel = 'toolbar.accessibilityLabel.hangup';
  label = 'toolbar.hangup';
  type = 'hangup';
  icon = LogoutIcon;

  /**
   * Initializes a new HangupButton instance.
   *
   * @param {Props} props - The read-only properties with which the new
   * instance is to be initialized.
   */
  constructor(props) {
    super(props);

    this._hangup = once(() => {
      sendAnalytics(createToolbarEvent('hangup'));
      props.dispatch(
        leaveConference(
          utils.isRemoteLogin(this.props.user) ? '/groups' : '/settings'
        )
      );
    });
  }

  /**
   * Handles clicking / pressing the button, and disconnects the conference.
   *
   * @protected
   * @returns {void}
   */
  _handleClick() {
    this._doHangup();
  }

  /**
   * Helper function to perform the actual hangup action.
   *
   * @override
   * @protected
   * @returns {void}
   */
  _doHangup() {
    this._hangup();
  }
}
HangupButton.defaultProps = {
  showLabel: true,
  style: {
    backgroundColor: '#6B6B6B',
    'box-shadow': '0px 4px 8px rgba(0, 0, 0, 0.15)',
    borderRadius: '4px',
    padding: '12px 16px'
  }
};

/**
 * Maps (parts of) the Redux state to the associated {@code HangupButton}'s props.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} ownProps - The own props of the component.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
  return {
    user: state['features/login'].user,
    _userIdleMode: state['features/settings'].userIdleMode
  };
}
export default React.memo(
  translate(connect(_mapStateToProps)(withBoundary(HangupButton)))
);
